import React, { Component } from 'react'
import _ from 'lodash'

import { Get } from 'utils/axios'
import { connect } from 'react-redux'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      countriesOption: [],
      statesOption: [],
      citiesOption: []
    }
    load = param => {
      if( param ){
        this.props.addLoadingContent()
      } else {
        this.props.removeLoadingContent()
      }
    }
    onChangeCountryHOC = ( key, val ) => this.setState({ [ key ]: val })

    getCountriesOption = () => Get(
      '/countries',
      this.getCountriesOptionSuccess,
      this.getCountriesOptionError,
      this.load,
      true
    )
    getCountriesOptionSuccess = payload => {
      let tmpClientCountries = _.map( this.props.clientCountries, val => val.iso2 )
      let tmp = _.map( 
        _.filter( payload.countries, val => tmpClientCountries.indexOf( val.iso2 ) > -1 ), 
        val => { return { ...val, currency_symbol: val.currency_symbol }}
      )
      this.setState({ countriesOption: tmp })
    }
    getCountriesOptionError = error => this.requestError( error )

    getStatesOption = countryId => Get(
      `/countries/${ countryId }/states`,
      this.getStatesOptionSuccess,
      this.getStatesOptionError,
      this.load,
      true
    )
    getStatesOptionSuccess = payload => this.setState({ statesOption: payload.states })
    getStatesOptionError = error => {}

    getCitiesOption = ( countryId, stateId ) => Get(
      `/countries/${ countryId }/states/${ stateId }/cities`,
      this.getCitiesOptionSuccess,
      this.getCitiesOptionError,
      this.load,
      true
    )
    getCitiesOptionSuccess = payload => this.setState({ citiesOption: payload.cities })
    getCitiesOptionError = error => {}

    render = () => {
      return (
        <WrappedComponent
          { ...this.props } 
          onChangeCountryHOC={ this.onChangeCountryHOC }
          getCountriesOption={ this.getCountriesOption }
          getStatesOption={ this.getStatesOption }
          getCitiesOption={ this.getCitiesOption }
          countriesOption={ this.state.countriesOption }
          statesOption={ this.state.statesOption }
          citiesOption={ this.state.citiesOption }
        />
      )
    }
  }

  const mapStateToProps = state => ({
    data: state,
    clientCountries: state.ClientReducer.clientCountries
  })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC
